<template>
  <Transition name="fade-scroll">
    <button
      v-show="visible"
      type="button"
      class="scroll-top"
      aria-label="Rolar para o topo"
      @click="scrollTop"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
        <path fill="currentColor" d="M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8l-8 8z"/>
      </svg>
    </button>
  </Transition>
</template>

<script>
export default {
  name: 'ScrollToTop',
  props: {
    threshold: { type: Number, default: 240 }
  },
  data() {
    return { visible: false }
  },
  mounted() {
    this._onScroll = () => {
      this.visible = (window.scrollY || document.documentElement.scrollTop || 0) > this.threshold
    }
    window.addEventListener('scroll', this._onScroll, { passive: true })
    this._onScroll()
  },
  beforeUnmount() {
    if (this._onScroll) window.removeEventListener('scroll', this._onScroll)
  },
  methods: {
    scrollTop() {
      try {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      } catch {
        window.scrollTo(0, 0)
      }
    }
  }
}
</script>

<style scoped>
.scroll-top {
  position: fixed;
  bottom: calc(20px + env(safe-area-inset-bottom));
  right: calc(20px + env(safe-area-inset-right));
  width: 48px;
  height: 48px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--color-accent);
  color: #fff;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25);
  z-index: 70;
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}
.scroll-top:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.3);
}
.scroll-top:active { transform: translateY(0); }

.fade-scroll-enter-active,
.fade-scroll-leave-active { transition: opacity 0.22s ease, transform 0.22s ease; }
.fade-scroll-enter-from,
.fade-scroll-leave-to { opacity: 0; transform: translateY(8px); }

/* Em desktop, esconder (atalho de teclado / mouse wheel resolvem). */
@media (min-width: 769px) {
  .scroll-top { display: none; }
}
</style>
